import { takeEvery, take, put, select } from 'redux-saga/effects';

import { getLogger } from '../../logger';

import actions, { LOAD_ATTR_GROUPS } from './actions';
import productsModule from '../products';
import intlModule from '../intl';

const { category: categoryEntity } = productsModule;

const logger = getLogger('carCreationWizard');

function* loadAttrGroupsSaga({ payload: { itemData, attributes } }) {
  const messages = yield select(intlModule.selectors.getMessages);
  const lang = yield select(intlModule.selectors.getLocale);

  yield put(categoryEntity.getOrFetchData({ id: itemData.category.id }));
  yield take('CATEGORY_FETCH_DATA_COMPLETE');

  const category = yield select(categoryEntity.selectors.getData);

  const [groupedAttrs, ungroupedAttrs] = groupAttributes(attributes, category.attribute_groups, lang);
  logger.debug('Set grouped attributes', [groupedAttrs, ungroupedAttrs]);
  yield put(
    actions.setAttributeGroups([...groupedAttrs, { id: 'others', name: messages.others, attributes: ungroupedAttrs }])
  );
}

export function* watchAttrGroupsActions() {
  logger.debug('Setup saga watcher', LOAD_ATTR_GROUPS);
  yield takeEvery(LOAD_ATTR_GROUPS, loadAttrGroupsSaga);
}

export default [watchAttrGroupsActions];

function groupAttributes(attributes, attrGroups, lang) {
  const groupedAttrs = attrGroups.map(group => ({
    id: group.attribute_group.id,
    name: group.attribute_group.name.find(trans => trans.lang === lang).name,
    attributes: group.attributes
      .map(({ attribute: { id } }) => attributes.find(attr => attr.id && attr.id === id))
      .filter(Boolean),
  }));
  const groupedAttrIds = [].concat(...groupedAttrs.map(({ attributes }) => attributes.map(({ id }) => id)));
  const ungroupedAttrs = attributes.filter(({ id }) => !groupedAttrIds.includes(id));

  return [groupedAttrs, ungroupedAttrs];
}
